import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import WarningIcon from './components/WarningIcon/WarningIcon';
import ErrorIcon from './components/ErrorIcon/ErrorIcon';
import Date from './components/Date/Date';
import DataInvolvedItem from './components/DataInvolvedItem/DataInvolvedItem';
import Details from './components/Details/Details';
import { archiveAlert, unarchiveAlert } from '../../../../ExperianActions';
import { Content, Icon, Sidebar, StyledAlert, StyledButton, Title } from './AlertStyles';
import ExperianContext from '../../../../ExperianContext';

const Alert = ({
  isArchived,
  alert: {
    DataInvolved: dataInvolved,
    Date: date,
    Details: details,
    Severity: severity,
    Title: title,
    AlertId,
    Type,
    ReadStatus,
    ArchiveStatus,
  },
}) => {
  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();
  const archiveAlertCallback = useCallback(() => {
    const alertData = {
      AlertId,
      Type,
      ReadStatus,
      ArchiveStatus,
    };
    if (isArchived) {
      return dispatch(unarchiveAlert(clientId, subscriberId, alertData));
    }
    return dispatch(archiveAlert(clientId, subscriberId, alertData));
  }, [clientId, subscriberId, AlertId, Type, ReadStatus, ArchiveStatus, isArchived, dispatch]);

  return (
    <StyledAlert>
      <Icon>{severity === 'red' ? <ErrorIcon /> : <WarningIcon />}</Icon>
      <Content>
        <Title>{title}</Title>
        <Date>{date}</Date>
        {dataInvolved && dataInvolved.length === 1 && <DataInvolvedItem data={dataInvolved[0]} />}
        {dataInvolved && dataInvolved.length > 1 && (
          <DataInvolvedItem
            data={{
              RecordInformation: 'Multiple',
              RecordSource: 'Multiple',
              RecordType: null,
            }}
          />
        )}
        <Details details={details} dataInvolved={dataInvolved} />
      </Content>
      <Sidebar>
        <StyledButton onClick={archiveAlertCallback} size="small">
          <i className="fas fa-archive" />
          {isArchived ? 'Unarchive' : 'Archive'}
        </StyledButton>
      </Sidebar>
    </StyledAlert>
  );
};

Alert.propTypes = {
  isArchived: PropTypes.bool.isRequired,
  alert: PropTypes.shape({
    Company: PropTypes.string,
    DataInvolved: PropTypes.arrayOf(
      PropTypes.shape({
        RecordInformation: PropTypes.string,
        RecordSource: PropTypes.string,
        RecordType: PropTypes.string,
      }),
    ),
    Date: PropTypes.string,
    Details: PropTypes.string,
    Severity: PropTypes.oneOf(['yellow', 'red']),
    Title: PropTypes.string,
    AlertId: PropTypes.string.isRequired,
    Type: PropTypes.string.isRequired,
    ReadStatus: PropTypes.string.isRequired,
    ArchiveStatus: PropTypes.string.isRequired,
  }).isRequired,
};

export default Alert;
